import React from 'react';
import { useTheme } from '../context/ThemeContext';
import DependencyGraph from './DependencyGraph';

const skillsWithProgress = [
  { name: 'Pain', progress: 13 },
  { name: 'Suffering', progress: 26 },
  { name: 'Existential dread', progress: 62 },
  { name: 'Fear of missing out (FOMO)', progress: 62 },
  { name: 'Жуть', progress: 26 },
  { name: 'Проклятие', progress: 14 },
];

const ToolsSection = () => {
  const { isDark } = useTheme();
  
  return (
    <section id="skills" className="tools-section">
      {/* Section Title */}
      <h2 className="section-title">
        SANE HEURISTICS <span className="section-title-faded">REFINE CHARACTERISTICS</span>
      </h2>
      <blockquote className="section-quote">
        <p>"Yes, sir, I understand, but just because AZ has an album cover with him wearing a phat brick, doesn't mean that we have any busted down or iced-out watches that transfer mana, adrenaline, or buffs through to your player-controlled character in World of Warcraft on the Bronzebeard server at the moment.<br /><br />Please contact John Neverdie Jacobs for further assistance."</p>
        <cite>-Gizzard Entertainment</cite>
      </blockquote>

      {/* Skills and Graph Container */}
      <div className="skills-graph-container">
        {/* Skills Progress Bars */}
        <div className="skills-progress-section">
          {skillsWithProgress.map((skill, index) => (
            <div key={index} className="skill-progress-item">
              <div className="skill-progress-header">
                <span className="skill-progress-name">{skill.name}</span>
                <span className="skill-progress-percentage">{skill.progress}%</span>
              </div>
              <div className="skill-progress-bar">
                <div 
                  className="skill-progress-fill" 
                  style={{ width: `${skill.progress}%` }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Dependency Graph */}
        <div className="dependency-graph-wrapper">
          <DependencyGraph />
        </div>
      </div>

      <style jsx>{`
        .tools-section {
          padding-bottom: 60px;
        }

        .section-title {
          font-family: 'Poppins', sans-serif;
          font-size: clamp(36px, 6vw, 56px);
          font-weight: 700;
          color: ${isDark ? '#fff' : '#151312'};
          line-height: 1;
          letter-spacing: -0.02em;
          margin: 0 0 32px 0;
          transition: color 0.3s ease;
        }

        .section-title-faded {
          color: ${isDark ? 'rgba(182, 180, 189, 0.2)' : 'rgba(21, 19, 18, 0.15)'};
        }

        .section-quote {
          font-family: 'Poppins', sans-serif;
          font-size: 15px;
          font-style: italic;
          color: ${isDark ? '#998f8f' : '#64748b'};
          line-height: 1.6;
          margin: -12px 0 32px 0;
          max-width: 600px;
          padding-left: 16px;
          border-left: 2px solid rgba(244, 108, 56, 0.5);
          transition: color 0.3s ease;
        }

        .section-quote p {
          margin: 0 0 8px 0;
        }

        .section-quote cite {
          font-size: 14px;
          color: #f46c38;
          font-style: normal;
        }

        .skills-graph-container {
          display: flex;
          gap: 48px;
          align-items: center;
        }

        .skills-progress-section {
          flex: 1;
          min-width: 0;
          display: grid;
          grid-template-columns: 1fr;
          gap: 24px;
        }

        .dependency-graph-wrapper {
          flex: 1;
          min-width: 0;
        }

        .skill-progress-item {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .skill-progress-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
        }

        .skill-progress-name {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 500;
          color: ${isDark ? '#fff' : '#151312'};
          transition: color 0.3s ease;
        }

        .skill-progress-percentage {
          font-family: 'Poppins', sans-serif;
          font-size: 14px;
          font-weight: 600;
          color: #f46c38;
        }

        .skill-progress-bar {
          width: 100%;
          height: 8px;
          background: ${isDark ? 'rgba(182, 180, 189, 0.15)' : 'rgba(100, 116, 139, 0.15)'};
          border-radius: 4px;
          overflow: hidden;
          transition: background-color 0.3s ease;
        }

        .skill-progress-fill {
          height: 100%;
          background: linear-gradient(90deg, #f46c38 0%, #ff8c5a 100%);
          border-radius: 4px;
          transition: width 1s ease-out;
        }

        @media (max-width: 900px) {
          .skills-graph-container {
            flex-direction: column;
            align-items: stretch;
          }

          .skills-progress-section {
            width: 100%;
          }

          .dependency-graph-wrapper {
            width: 100%;
            max-width: 360px;
            margin: 0 auto;
          }
        }

        @media (max-width: 600px) {
          .section-title {
            font-size: 32px;
            margin-bottom: 24px;
          }
        }
      `}</style>
    </section>
  );
};

export default ToolsSection;
